module.exports = __webpack_public_path__ + "static/media/Terasy_Krizovy_sklep.81a6760d.md";